/** Тип таблицы. */
export enum TableType {
    Order = "order",
    Sale = "sale",
    Task = "task",
    Client = "client",
    GoodRegistration = "good-registration",
    GoodWriteOff = "good-write-off",
    GoodInventory = "good-inventory",
    Good = "good",
    Transaction = "transaction",
    Salary = "salary",
    Report = "report",
    Work = "work",

    AdminConversion = "admin-conversion",
    AdminCompanies = "admin-companies",
    AdminUsers = "admin-users",
}
